import { Text } from '@/shared/ui/primitives';
import type { FC } from 'react';
import { ArrowDown, ArrowUp } from 'lucide-react';

import type { SortDirection } from '@/shared/lib/sort';
import styles from './SortChip.module.css';

interface SortChipProps {
  label: string;
  direction: SortDirection;
  onClick: () => void;
  testId?: string;
}

export const SortChip: FC<SortChipProps> = ({ label, direction, onClick, testId }) => (
  <Text
    variant="subheadline"
    weight="medium"
    as="button"
    type="button"
    className={styles.button}
    data-testid={testId}
    aria-haspopup="dialog"
    aria-label={`Sort by ${label} ${direction === 'asc' ? 'ascending' : 'descending'}`}
    onClick={onClick}
  >
    <span>{label}</span>
    {direction === 'asc' ? <ArrowUp size={14} /> : <ArrowDown size={14} />}
  </Text>
);
